// api/hook/useFreeCourses.ts
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../config";
import { Course } from "../../../types/course";

// Shape returned directly by the API (before mapping)
interface APICourse {
  id: number;
  publish: boolean;
  courseName: string;
  courseDescription: string;
  amount: number;
  tenor: number;
  tenorType: number;
  enrolled: number;
  participants: number;
  shortVideoEnabled: boolean;
  free: boolean;
  certFree: boolean;
  courseCategory: {
    id: number;
    categoryName: string;
    description: string;
  };
}

// Map API shape → Course type expected by CourseCard
const mapCourse = (c: APICourse): Course => ({
  id: c.id,
  courseName: c.courseName,
  categoryName: c.courseCategory?.categoryName ?? "",
  courseDescription: c.courseDescription,
  amount: c.amount,
  tenor: c.tenor,
  tenorType: c.tenorType,
  enrolled: c.enrolled,
  participants: c.participants,
  shortVideoEnabled: c.shortVideoEnabled,
  free: c.free,
  certFree: c.certFree,
});

const fetchFreeCourses = async (): Promise<Course[]> => {
  const { data } = await apiClient.get<APICourse[]>("/public/getAllCourse");
  return data.filter((c) => c.publish && c.free && c.certFree).map(mapCourse);
};

export const useFreeCourses = () =>
  useQuery({
    queryKey: ["freeCourses"],
    queryFn: fetchFreeCourses,
    staleTime: 1000 * 60 * 5,
  });

export const useAllFreeCourses = () =>
  useQuery({
    queryKey: ["allFreeCourses"],
    queryFn: fetchFreeCourses,
    staleTime: 1000 * 60 * 5,
  });
